/* EWA — shoppable coverflow media slider. Infinite loop via DOM cloning. */
(function () {
  if (customElements.get('aycan-media-slider')) return;

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SCROLL_MS = REDUCED ? 0 : 520;
  var MOBILE = window.matchMedia('(max-width: 749px)');

  class AycanMediaSlider extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;

      this.track = this.querySelector('[data-ms-track]');
      this.stage = this.querySelector('[data-ms-stage]');
      this.nav = this.querySelector('[data-ms-nav]');
      if (!this.track) return;

      this._setupClones();

      this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-ms-slide]'));
      if (!this.slides.length) return;

      this.prevBtn = this.querySelector('[data-ms-prev]');
      this.nextBtn = this.querySelector('[data-ms-next]');
      this.muted = true;
      this.active = -1;
      this._animating = false;
      this._inView = false;
      this._scrollEndTimer = null;
      this._jumpTimer = null;
      this._navRaf = 0;

      this._io = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        this._inView = !!(entry && entry.isIntersecting);
        if (this._inView) this.playActive();
        else this.pauseAll();
      }.bind(this), { threshold: 0.15, rootMargin: '40px 0px' });
      this._io.observe(this);

      this.bind();
      void this.track.offsetHeight;
      this._initScroll();
      this.update();
      this._scheduleNavPosition();
    }

    disconnectedCallback() {
      if (this._io) this._io.disconnect();
    }

    _setupClones() {
      var originals = Array.prototype.slice.call(this.track.querySelectorAll('[data-ms-slide]'));
      this._n = originals.length;
      if (!this._n) return;

      var pre = document.createDocumentFragment();
      originals.forEach(function (el) {
        var c = el.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        pre.appendChild(c);
      });
      this.track.insertBefore(pre, this.track.firstChild);

      originals.forEach(function (el) {
        var c = el.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        this.track.appendChild(c);
      }.bind(this));
    }

    _initScroll() {
      var n = this._n;
      if (!n) return;
      var el = this.slides[n];
      if (!el) return;
      this.track.scrollLeft = el.offsetLeft + el.offsetWidth / 2 - this.track.clientWidth / 2;
    }

    bind() {
      var self = this;
      var raf;

      this.track.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = 0;
          self.update();
          self._scheduleNavPosition();
        });

        if (self._animating) return;

        clearTimeout(self._jumpTimer);
        self._jumpTimer = setTimeout(function () {
          self._jumpIfNeeded();
        }, 280);
      }, { passive: true });

      if ('onscrollend' in window) {
        this.track.addEventListener('scrollend', function () {
          if (self._animating) self._finishScroll();
        }, { passive: true });
      }

      if (this.prevBtn) this.prevBtn.addEventListener('click', function () { self.go(-1); });
      if (this.nextBtn) this.nextBtn.addEventListener('click', function () { self.go(1); });

      this.slides.forEach(function (slide, i) {
        slide.addEventListener('click', function (e) {
          if (i !== self.active && !e.target.closest('a, button')) {
            e.preventDefault();
            self.centerIndex(i);
          }
        });
        var mute = slide.querySelector('[data-ms-mute]');
        if (mute) mute.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); self.toggleMute(); });
        var pause = slide.querySelector('[data-ms-pause]');
        if (pause) pause.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); self.togglePause(slide); });
      });

      window.addEventListener('resize', function () {
        self._initScroll();
        self.update();
        self._scheduleNavPosition();
      });
    }

    _realIdx(i) {
      var n = this._n;
      return ((i - n) % n + n) % n;
    }

    center() { return this.track.scrollLeft + this.track.clientWidth / 2; }

    nearest() {
      var c = this.center(), best = 0, min = Infinity;
      this.slides.forEach(function (s, i) {
        var d = Math.abs(s.offsetLeft + s.offsetWidth / 2 - c);
        if (d < min) { min = d; best = i; }
      });
      return best;
    }

    update() {
      var self = this;
      var idx = this.nearest();
      var activeRi = this._realIdx(idx);

      this.slides.forEach(function (s, i) {
        var isActive = self._realIdx(i) === activeRi;
        s.classList.toggle('is-active', isActive);
      });

      if (idx !== this.active) {
        this.active = idx;
        this.playActive();
      }
    }

    pauseAll() {
      this.slides.forEach(function (s) {
        var v = s.querySelector('video');
        if (v) v.pause();
      });
    }

    playActive() {
      if (!this._inView) return;

      var self = this;
      var activeRi = this._realIdx(this.active);
      this.slides.forEach(function (s, i) {
        var v = s.querySelector('video');
        if (!v) return;
        if (self._realIdx(i) === activeRi && s.getAttribute('aria-hidden') !== 'true') {
          v.muted = self.muted;
          if (!REDUCED) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        } else {
          v.pause();
        }
      });
    }

    _finishScroll() {
      clearTimeout(this._scrollEndTimer);
      this._animating = false;
      this.track.style.scrollSnapType = '';
      this._jumpIfNeeded();
      this.update();
      this._scheduleNavPosition();
    }

    centerIndex(i) {
      var s = this.slides[i];
      if (!s || this._animating) return;

      var self = this;
      this._animating = true;
      this.track.style.scrollSnapType = 'none';

      var target = s.offsetLeft + s.offsetWidth / 2 - this.track.clientWidth / 2;

      if (REDUCED) {
        this.track.scrollLeft = target;
        this._finishScroll();
        return;
      }

      this.track.scrollTo({ left: target, behavior: 'smooth' });

      clearTimeout(this._scrollEndTimer);
      this._scrollEndTimer = setTimeout(function () {
        self._finishScroll();
      }, SCROLL_MS);
    }

    go(dir) {
      if (this._animating) return;
      var idx = this.active >= 0 ? this.active : this.nearest();
      this.centerIndex(idx + dir);
    }

    _jumpIfNeeded() {
      if (this._animating) return;

      var n = this._n;
      var idx = this.nearest();
      var jumpTo = null;
      if (idx < n) jumpTo = n + idx;
      else if (idx >= 2 * n) jumpTo = n + (idx - 2 * n);
      if (jumpTo === null) return;

      var el = this.slides[jumpTo];
      if (!el) return;

      this.track.scrollLeft = el.offsetLeft + el.offsetWidth / 2 - this.track.clientWidth / 2;
      this.active = jumpTo;
      this.update();
      this._scheduleNavPosition();
    }

    _scheduleNavPosition() {
      if (this._navRaf) return;
      this._navRaf = requestAnimationFrame(function () {
        this._navRaf = 0;
        this.updateNavPosition();
      }.bind(this));
    }

    updateNavPosition() {
      if (!this.nav || !this.stage || this.classList.contains('aycan-ms--nav-below')) return;
      if (!this.prevBtn || !this.nextBtn) return;

      var active = this.slides[this.active >= 0 ? this.active : this.nearest()];
      if (!active) return;

      var stageRect = this.stage.getBoundingClientRect();
      var mediaShell = active.querySelector('.aycan-ms__media-shell') || active.querySelector('.aycan-ms__media-wrap');
      if (!mediaShell) return;

      var slideRect = active.getBoundingClientRect();
      var mediaRect = mediaShell.getBoundingClientRect();
      var rem = parseFloat(getComputedStyle(this).fontSize) || 10;
      var gapPx = (parseFloat(getComputedStyle(this).getPropertyValue('--ms-nav-gap')) || 1.5) * rem;
      var outsetPx = (parseFloat(getComputedStyle(this).getPropertyValue('--ms-nav-outset')) || 1.25) * rem;
      var pad = gapPx + outsetPx;
      var stageW = stageRect.width;
      var slideLeft = slideRect.left - stageRect.left;
      var slideRight = slideRect.right - stageRect.left;
      var prevW = this.prevBtn.offsetWidth;
      var nextW = this.nextBtn.offsetWidth;
      var navTop = mediaRect.top - stageRect.top + mediaRect.height / 2;
      var edgeMin = MOBILE.matches ? 4 : 8;

      this.prevBtn.style.top = navTop + 'px';
      this.nextBtn.style.top = navTop + 'px';
      this.prevBtn.style.insetInlineStart = Math.max(edgeMin, slideLeft - prevW - pad) + 'px';
      this.nextBtn.style.insetInlineEnd = Math.max(edgeMin, stageW - slideRight - nextW - pad) + 'px';

      this.nav.classList.add('is-ready');
      this.nav.removeAttribute('aria-hidden');
    }

    toggleMute() {
      this.muted = !this.muted;
      var self = this;
      var realActive = this.slides[this.active];
      var v = realActive && realActive.querySelector('video');
      if (v) { v.muted = this.muted; if (!this.muted && this._inView) v.play().catch(function () {}); }
      this.querySelectorAll('[data-ms-mute]').forEach(function (b) { b.classList.toggle('is-muted', self.muted); });
    }

    togglePause(slide) {
      var v = slide.querySelector('video');
      if (!v) return;
      if (v.paused) v.play().catch(function () {}); else v.pause();
      slide.classList.toggle('is-paused', v.paused);
    }
  }

  customElements.define('aycan-media-slider', AycanMediaSlider);

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ms-atc]');
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-ms-atc');
    if (!id || btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');

    var drawer = document.querySelector('cart-drawer');
    var body = { items: [{ id: id, quantity: 1 }] };
    if (drawer && drawer.getSectionsToRender) {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        setTimeout(function () { btn.classList.remove('is-added'); }, 1600);
        if (drawer && data.sections) {
          drawer.renderContents(data);
          if (drawer.open) drawer.open();
        } else {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        }
      })
      .catch(function () { btn.classList.remove('is-loading'); window.location.href = window.Shopify.routes.root + 'cart'; });
  });
})();
